import React from "react";
import { useTranslation } from "react-i18next";
import { detectWebDeviceType } from "../../../utils";
import { Badge } from "reactstrap";

function getFreeQtyForOffer(offer, quantity) {
  const rawFreeQty = offer.repeat_for_multiple
    ? Math.floor(quantity / offer.buy_qty) * offer.free_qty
    : quantity >= offer.buy_qty
    ? offer.free_qty
    : 0;

  return offer.max_free_per_order > 0
    ? Math.min(rawFreeQty, offer.max_free_per_order)
    : rawFreeQty;
}

function FreeOfferModal({ offers, quantity, selectedPromotionId, onSelect, onClose }) {
  const { t } = useTranslation();
  const deviceType = detectWebDeviceType();

  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-50 backdrop-blur-md drop-shadow-sm">
      <div className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-40"></div>
      <section
        className={`flex flex-col font-semibold leading-6 bg-white rounded-[25px] text-zinc-800 z-40 ${
          deviceType === "tablet" ? "px-12 pt-8 pb-12" : "px-12 pt-8 pb-12"
        } ${deviceType === "tablet" ? "fixed left-20" : "relative"} max-md:px-5 text-lg`}
        style={{ width: deviceType === "tablet" ? "700px" : "800px" }}
      >
        <header className="flex gap-5 text-3xl max-md:flex-wrap max-md:max-w-full mb-2">
          <h1 className={`my-auto ${deviceType === "tablet" ? "flex-auto text-xl" : "flex-auto"}`}>
            {t("Choose Your Free Item")}
          </h1>
          <button
            type="button"
            onClick={onClose}
            className="text-zinc-800 absolute top-5 right-5 bg-transparent"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </header>

        <main className="mt-6">
          <div className="flex flex-wrap gap-4">
            {offers?.map((offer) => {
              const freeQty = getFreeQtyForOffer(offer, quantity);
              const isSelected = offer.promotion_id === selectedPromotionId;
              const isDisabled = freeQty <= 0;

              return (
                <div
                  key={offer.promotion_id}
                  onClick={() => !isDisabled && onSelect(offer)}
                  className={`w-[160px] border rounded-lg p-3 shadow-sm transition-opacity duration-200 ${
                    isDisabled
                      ? "border-gray-300 bg-gray-100 text-gray-400 cursor-not-allowed opacity-60"
                      : isSelected
                      ? "border-emerald-600 ring-2 ring-emerald-600 text-gray-800 cursor-pointer"
                      : "border-gray-200 text-gray-800 hover:shadow-md cursor-pointer"
                  }`}
                >
                  <div className="flex flex-col justify-center items-center rounded-md">
                    <Badge
                      style={{
                        backgroundColor: "#065f46",
                        color: "white",
                        alignSelf: "flex-end",
                        fontWeight: "600",
                        width: 50,
                        height: 50,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: -3,
                        marginRight: -3,
                        marginBottom: 3,
                        borderRadius: 25,
                        zIndex: 10,
                      }}
                    >
                      x{freeQty}
                    </Badge>

                    <img
                      loading="lazy"
                      src={offer.free_product_image_url}
                      className="h-28 w-auto object-contain"
                      alt={offer.free_product_name}
                    />
                  </div>
                  <div className="text-sm font-semibold mt-2 break-words whitespace-normal overflow-hidden">
                    {offer.free_product_name}
                  </div>
                  <div className="mt-1 text-xs text-gray-500">
                    {t("Buy")} {offer.buy_qty} {t("get")} {offer.free_qty}
                  </div>
                  <div className="mt-1 text-sm font-bold mb-0">
                    {t("Worth")} EGP {offer.free_unit_price?.toFixed(2)}
                  </div>
                </div>
              );
            })}
          </div>
        </main>
      </section>
    </div>
  );
}

export default FreeOfferModal;